<template>
  <div class="photo">
    <h1>PHOTO</h1>
    <!-- <Item v-for="photo in allPhotos" v-bind:key="photo.id" :thumbnailSrc="photo.data.photo_thumbnail.url" @click="goPhoto(photo.id)" /> -->
    <img :src="currentPhoto" @click="goPhoto(currentIndex++)"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import Item from '@/components/Item.vue'

export default {
  name: 'photo',
  components: {
    // Item
  },
  data() {
    return {
      allPhotos: [],
      currentPhoto: '',
      currentIndex: 0
    }
  },
  methods: {
    goPhoto(photoId) {
      this.$router.push({ name: 'photo', params: { photo_id: photoId } });
    }
  },
  created() {
    var that = this;
    this.$store.dispatch('fetchPhotos', { vm: this, cb:
      function(results) {
        that.allPhotos = results;

        var photoIndex = 0;
        if (that.$route.params.photo_id < that.allPhotos.length - 1) {
          photoIndex = that.$route.params.photo_id;
        }
        that.currentPhoto = that.allPhotos[that.$route.params.photo_id].data.photo.url;
        that.currentIndex = that.$route.params.photo_id;
      }
    });
  }
}
</script>
